import { Trans } from '@lingui/react';
import { isNil } from 'lodash-es';

export const McApprovalStatus = ({ children }: { children: boolean | null | undefined }) => {
  if (isNil(children)) {
    return <Trans id="Waiting for decision" />;
  }
  if (children) {
    return <Trans id="Approved" />;
  }
  return <Trans id="Rejected" />;
};
